import { Injectable } from '@angular/core';

import { FvmsApiMessage } from "src/app/shared/service/fvms.api.message.ko.kr";

@Injectable({providedIn: 'root'})
export class FvmsUtilService {
    constructor(
        
    ) {

    }

    getRandom(min:number,max:number){
        return Math.floor(Math.random()*(max-min+1)) + min;
    }

    getErrorMessage(messageId:string){
        return FvmsApiMessage.find(item => item.id === messageId);
    }
}